module.exports = __webpack_public_path__ + "static/media/chiko_victory.27f1a768.jpg";